"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "Diş sıkma (masseter) botoksu nedir?",
  answer: "Diş sıkma botoksu, çene köşesinde yer alan ve en güçlü çiğneme kası olan masseter kasına botulinum toksini enjekte edilmesi işlemidir. Bu uygulama, istemsiz diş sıkma ve gıcırdatma (bruksizm) sorunlarını gidermek, çene eklemi ağrılarını azaltmak ve yüzün alt kısmındaki kare görünümü yumuşatarak daha estetik bir V-hattı oluşturmak için tercih edilir."
}, {
  question: "Tedavi süreci ve uygulama basamakları nasıldır?",
  answer: "İşlem öncesinde uzman hekimimiz çene kaslarınızın gücünü ve enjeksiyon noktalarını titizlikle belirler. Uygulama bölgesi dezenfekte edildikten sonra, çok ince uçlu iğnelerle belirlenen kas noktalarına küçük dozlarda botoks enjekte edilir. Tüm süreç genellikle 10-15 dakika sürer ve hasta işlemden hemen sonra günlük yaşantısına kesintisiz devam edebilir."
}, {
  question: "İşlemin etkisi ne zaman başlar ve ne kadar sürer?",
  answer: "Enjeksiyonun etkisi genellikle 3 ila 7 gün içinde kaslarda gevşeme olarak hissedilmeye başlar. Tam etkinin oturması ve çene hattındaki görsel incelme yaklaşık 2-4 hafta sürer. Botoksun etkisi kişiden kişiye değişmekle birlikte ortalama 4-6 ay devam eder. Düzenli tekrarlanan seanslar, kasın aşırı gücünü kademeli olarak azaltmaya yardımcı olur."
}, {
  question: "Diş sıkma botoksu ağrılı bir işlem midir?",
  answer: "Hayır, işlem oldukça konforludur. Uygulama sırasında kullanılan iğneler çok ince olduğu için sadece hafif bir batma hissi duyulur. Hassas hastalarımız için işlem öncesinde bölgeye lokal anestezik kremler uygulanarak konfor düzeyi en üst seviyeye çıkarılır."
}, {
  question: "Uygulama sonrası nelere dikkat edilmelidir?",
  answer: "İşlemden sonraki ilk 24 saat boyunca uygulama bölgesine sert masaj yapılmamalı, aşırı sıcak banyo veya saunadan kaçınılmalıdır. Ayrıca botoksun enjekte edilen bölgede kalması için ilk birkaç saat başın dik tutulması ve ağır egzersiz yapılmaması önerilir. Diş hekiminizin önerdiği rutin kontrollere uymak tedavinin başarısını artırır."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="169251" id="sık-sorulan-sorular" className="bg-background py-20 md:py-32 overflow-hidden">
      <div ref={ref} className={`container mx-auto px-4 sm:px-6 max-w-[800px] transition-all duration-[800ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-6 tracking-tight font-serif">
            Sıkça Sorulan Sorular
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto leading-relaxed font-sans">
            Ağız ve diş sağlığı tedavilerimiz, süreçlerimiz ve merak ettiğiniz tüm detaylar hakkında bilgi edinin.
          </p>
        </div>

        <div className="bg-transparent rounded-none p-6 md:p-10 lg:p-12 border border-transparent shadow-none">
          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-b border-primary/20 bg-transparent rounded-none px-6 data-[state=open]:border-primary transition-all duration-500 ease-in-out hover:bg-secondary/40 shadow-none group overflow-hidden">
                <AccordionTrigger className="text-foreground font-medium font-sans text-base md:text-lg hover:no-underline py-6 group-hover:text-primary transition-colors">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground font-sans leading-relaxed text-base md:text-[1.05rem] pb-8 pt-2">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        <div className="mt-16 flex flex-col items-center justify-center text-center space-y-6">
          <p className="text-xl font-medium text-foreground tracking-tight font-serif">
            Aklınıza Takılan Başka Bir Soru mu Var?
          </p>
          <Button asChild variant="outline" size="lg" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground border h-14 px-10 rounded-none transition-all duration-500 ease-in-out shadow-none hover:shadow-none text-base font-medium tracking-wide">
            <Link to="/ContactPage">Uzmanlarımıza Danışın</Link>
          </Button>
        </div>
      </div>
    </section>;
}